import { render, staticRenderFns } from "./BtnInserirPleito.vue?vue&type=template&id=6cb259f6"
import script from "./BtnInserirPleito.vue?vue&type=script&lang=js"
export * from "./BtnInserirPleito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports